import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const BenefitApproval = ({ color, size = IconScale.M }: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.error.main;
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M8.34147 15.0046C9.26195 15.0046 10.0081 15.7508 10.0081 16.6713C12.7328 16.6713 15.2392 17.6052 17.2248 19.1705L20.8415 19.1713C23.0617 19.1713 25.0565 20.136 26.4298 21.6691L31.6748 21.6713C34.9953 21.6713 37.8622 23.6133 39.2017 26.4237C35.2603 31.6247 28.878 35.0047 21.6748 35.0047C17.0237 35.0047 13.0911 33.9992 9.90667 32.2413C9.67595 32.8805 9.06212 33.338 8.34147 33.338H3.34147C2.421 33.338 1.6748 32.5917 1.6748 31.6713V16.6713C1.6748 15.7508 2.421 15.0046 3.34147 15.0046H8.34147ZM10.0098 20.0047L10.0081 28.3732L10.0837 28.4286C13.0734 30.5295 16.9717 31.6713 21.6748 31.6713C26.6815 31.6713 31.3392 29.7452 34.7333 26.4555L34.9548 26.233L34.7562 26.0657C33.9828 25.4607 33.0342 25.0851 32.0165 25.0161L31.6748 25.0047L28.1553 25.003C28.2772 25.5395 28.3415 26.0978 28.3415 26.6713V28.338H13.3415V25.0047L24.6582 25.003L24.6008 24.8722C23.9667 23.5495 22.655 22.6133 21.1155 22.5135L20.8415 22.5047L15.9591 22.5043C14.4471 20.962 12.3402 20.005 10.0098 20.0047ZM6.6748 18.338H5.00814V30.0047H6.6748V18.338ZM22.7522 5.96355L23.341 6.55315L23.9307 5.96355C25.5578 4.33637 28.1962 4.33637 29.8233 5.96355C31.4505 7.59073 31.4505 10.2289 29.8233 11.8561L23.3415 18.338L16.8597 11.8561C15.2325 10.2289 15.2325 7.59073 16.8597 5.96355C18.4868 4.33637 21.125 4.33637 22.7522 5.96355ZM19.2167 8.32057C18.9273 8.60985 18.8953 9.05889 19.119 9.38242L19.2148 9.4973L23.3398 13.6229L27.4663 9.49909C27.7555 9.2098 27.7877 8.76077 27.5627 8.43598L27.4663 8.32057C27.177 8.03128 26.728 7.99915 26.4028 8.22439L26.2873 8.32092L23.3388 11.2686L20.3933 8.31878L20.2798 8.22413C19.955 7.99915 19.506 8.03128 19.2167 8.32057Z"
        fill={color}
      />
    </svg>
  );
};

export default BenefitApproval;
